<mat-card class="flex flex-col h-full w-full shadow-lg p-0">
  <mat-card-title class="h-auto relative">
    @if (isLoading) {
      <div class="absolute top-0 left-0 w-full z-10">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
    <div class="flex justify-between items-center p-4 theme-bg-1">
      <div class="w-1/2 font-semibold text-lg">
        <ng-content select="[headerTitle]"></ng-content>
      </div>

      <div class="flex items-center justify-end">
        <em matTooltip="Thumbnail size" class="material-icons"> view_module</em>

        <mat-slider
          [max]="5"
          [min]="3"
          [discrete]="true"
          [showTickMarks]="true"
          (ngModelChange)="changeDetectorRef.detectChanges()"
        >
          <input matSliderThumb [(ngModel)]="numColumns" #slider />
        </mat-slider>
      </div>
    </div>
  </mat-card-title>

  <mat-card-content
    #scrollableContainer
    id="scrollable-content"
    cdkScrollable
    class="mt-4 p-4 flex-grow"
    [ngClass]="{ 'overflow-y-auto': hasInfiniteScroll }"
  >
    @if (imageList.length !== 0) {
      <mat-grid-list
        [cols]="numColumns"
        [gutterSize]="gutterSize"
        [rowHeight]="'24rem'"
      >
        @for (img of imageList; track $index; let i = $index) {
          <mat-grid-tile class="relative">
            <div
              class="flex flex-col w-full h-full p-0 text-center border-color-1 shadow-2xl"
              [ngClass]="{
                'opacity-50 grayscale': img.corrupted,
              }"
            >
              <div
                class="flex-grow overflow-hidden p-0 relative group"
                [ngClass]="{
                  'cursor-pointer': !img.corrupted,
                  'cursor-not-allowed': img.corrupted,
                }"
              >
                @if (displayCheckbox && !img.corrupted) {
                  <mat-checkbox
                    (keyup)="(null)"
                    (click)="$event.stopPropagation()"
                    name="galleryViewerCheckbox"
                    [(ngModel)]="img.selected"
                    class="!absolute !top-1 !right-1 z-10"
                  ></mat-checkbox>
                }
                @if (img.corrupted) {
                  <mat-icon
                    class="!absolute !top-1 !left-1 z-10"
                    matTooltip="Corrupted information"
                  >
                    broken_image
                  </mat-icon>
                }
                <img
                  [ngClass]="{
                    'border border-blue-color-1--2': selectedImgId === img.id,
                  }"
                  [id]="img.id"
                  class="h-full max-w-full object-contain m-auto"
                  [ngSrc]="img.src || uiHelper.placeholderPath"
                  fill
                  [alt]="img.alt"
                  (error)="onImageLoadError($event, img)"
                  (keyup)="(null)"
                  (click)="!img.corrupted && onImageClick(img)"
                />

                @if (
                  !img.corrupted &&
                  hoverActions.length &&
                  hoverActionsEnabled &&
                  (img.hasOwnProperty('imageLoaded') ? img.imageLoaded : true)
                ) {
                  <div
                    class="absolute bottom-0 w-full flex justify-center items-center invisible group-hover:visible"
                    #hoverActionContainer
                  >
                    @for (action of hoverActions; track $index) {
                      <div [class]="'w-full h-full ' + action.color">
                        <button
                          mat-button
                          class="flex justify-center items-center w-full h-full"
                          (click)="
                            $event.stopPropagation();
                            onHoverActionClick(img.id, action.id)
                          "
                          [matTooltip]="
                            hoverActionContainer.offsetWidth >
                            HOVER_ACTION_MIN_WIDTH
                              ? ''
                              : action.label
                          "
                        >
                          <mat-icon>{{ action.icon }}</mat-icon>
                          @if (
                            hoverActionContainer.offsetWidth >
                            HOVER_ACTION_MIN_WIDTH
                          ) {
                            <span class="ml-2">
                              {{ action.label }}
                            </span>
                          }
                        </button>
                      </div>
                    }
                  </div>
                }
              </div>
              <div
                class="flex items-center overflow-y-auto theme-bg-1 !border-0 text-center"
              >
                <div class="flex-1 flex justify-center">
                  <ng-container
                    *ngTemplateOutlet="
                      itemTemplateRef;
                      context: { image: img, index: i }
                    "
                  ></ng-container>
                </div>

                @if (img.comments && img.comments.length !== 0) {
                  @if (img.comments && img.comments.length !== 0) {
                    <div
                      class="p-1 text-center w-[35px] flex justify-center items-center"
                    >
                      <mat-icon class="material-icons-outlined text-[20px] mt-1"
                        >comment</mat-icon
                      >
                    </div>
                  }
                }
              </div>
            </div>
          </mat-grid-tile>
        }
      </mat-grid-list>
    }
  </mat-card-content>
  <phoenix-scroll-to-top
    [containerId]="'scrollable-content'"
  ></phoenix-scroll-to-top>
</mat-card>
@if (sideButtons.length && displayCheckbox && checkBoxSelected) {
  <phoenix-side-buttons
    [mainButtonImage]="'settings'"
    positionButton="right"
    positionOptions="down"
    [buttons]="sideButtons"
    (buttonClicked)="listAction.emit($event)"
  ></phoenix-side-buttons>
}
